import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from "react-country-flag";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { applyLocaleUnitDefaults } from "@/lib/unitPreferences";

// Language configurations with display names and country codes for flags
export const languages = [
    { code: 'en', name: 'English (US)', country: 'US' },
    { code: 'en-GB', name: 'English (UK)', country: 'GB' },
    { code: 'es', name: 'Español', country: 'ES' },
    { code: 'fr', name: 'Français', country: 'FR' },
    { code: 'de', name: 'Deutsch', country: 'DE' },
    { code: 'zh', name: '中文', country: 'CN' },
    { code: 'pt', name: 'Português', country: 'PT' },
    { code: 'ar', name: 'العربية', country: 'SA' },
    { code: 'hi', name: 'हिन्दी', country: 'IN' },
    { code: 'ja', name: '日本語', country: 'JP' },
    { code: 'ko', name: '한국어', country: 'KR' },
    { code: 'ru', name: 'Русский', country: 'RU' },
    { code: 'it', name: 'Italiano', country: 'IT' },
    { code: 'vi', name: 'Tiếng Việt', country: 'VN' },
];

// Export supported language codes for use in other modules
export const SUPPORTED_LANGUAGE_CODES = languages.map(l => l.code);

export const LanguageSelector = () => {
    const { i18n } = useTranslation();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="rounded-full w-9 h-9 bg-black/20 hover:bg-black/40 text-foreground transition-colors backdrop-blur-sm border border-white/10">
                    <ReactCountryFlag
                        countryCode={languages.find(l => l.code === i18n.language)?.country || 'US'}
                        svg
                        style={{
                            width: '1.5em',
                            height: '1.5em',
                        }}
                    />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" collisionPadding={16} className="max-h-[min(var(--radix-dropdown-menu-content-available-height,300px),300px)] overflow-y-auto">
                {languages.map((lang) => (
                    <DropdownMenuItem
                        key={lang.code}
                        onClick={() => {
                            i18n.changeLanguage(lang.code);
                            applyLocaleUnitDefaults(lang.code);
                        }}
                        className="gap-2 cursor-pointer"
                    >
                        <ReactCountryFlag countryCode={lang.country} svg />
                        <span>{lang.name}</span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
